import React, { useState, useEffect } from "react";
import { Column, Row, Text, Button, Input, Modal } from "@amzn/meridian";
import { setShowWorkflowHeader } from "src/store/workflowSlice";
import { useAppDispatch } from "src/store/store";

interface DrumCountStepProps {
  humanText: string;
  onComplete: (data: { drumCount: number }) => void;
}

const DrumCountStep: React.FC<DrumCountStepProps> = ({
  humanText,
  onComplete,
}) => {
  const dispatch = useAppDispatch();
  
  useEffect(() => {
    dispatch(setShowWorkflowHeader(false));
  }, []);

  const [drumCount, setDrumCount] = useState<string>("");
  const [error, setError] = useState<string>("");


  const handleSubmit = () => {
    const count = parseInt(drumCount, 10);
    
    if (isNaN(count) || count <= 0) {
      setError("Please enter a valid number greater than 0");
      return;
    }

    if (count > 100) {
      setError("Please enter a number less than or equal to 100");
      return;
    }
    dispatch(setShowWorkflowHeader(true));
    onComplete({ drumCount: count });
  };

  const handleInputChange = (value: string) => {
    setDrumCount(value);
    setError("");
  };

  return (
    <Modal open={true} title="Drum Count">
      <Column spacing="400">
        <Text>{humanText}</Text>
        
        <Input
          value={drumCount}
          onChange={(value) => handleInputChange(value)}
          type="number"
          placeholder="Enter number of drums"
        />
        
        {error && (
          <Text type="b200" color="error">
            {error}
          </Text>
        )}

        <Row alignmentHorizontal="end">
          <Button
            type="primary"
            onClick={handleSubmit}
            disabled={!drumCount}
          >
            Continue
          </Button>
        </Row>
      </Column>
    </Modal>
  );
};

export default DrumCountStep;
